import ReviewDecisionModal from './ReviewDecisionModal';

import PortalButton from './PortalButton';
import React, { useState } from 'react';
import { saveAs } from 'file-saver';
import { MdDownload, MdEdit } from 'react-icons/md';
import { usePortalMutation, usePortalDownload } from '../hooks';
import { ErrorNotice, Status } from './Feedback';
export default function DocumentReview({ application, document }) {
  const [reviewing, setReviewing] = useState(false);
  const decision = usePortalMutation(
      `inscricoes/${application.id}/documentos/${document.id}/decisao`
    ),
    download = usePortalDownload();
  return (
    <div className="portal-admin-document">
      <div className="portal-admin-row">
        <div>
          <h3>{document.requirement?.title || document.file_name}</h3>
          <Status value={document.status} />
        </div>
        <PortalButton
          className="btn btn-secondary hidethis"
          disabled={
            download.isLoading ||
            !download.allowed(`inscricoes/${application.id}/documentos/${document.id}/download`)
          }
          onClick={() =>
            download.mutate(
              {
                path: `inscricoes/${application.id}/documentos/${document.id}/download`,
              },
              {
                onSuccess: (blob) => saveAs(blob, document.file_name),
              }
            )
          }
          type="button"
        >
          <MdDownload /> Baixar documento
        </PortalButton>
      </div>
      <p>{document.file_name}</p>
      {document.reason && <p>{document.reason}</p>}
      <ErrorNotice error={download.error} />
      {['under_review', 'documents_pending', 'rejected'].includes(application.status) && (
        <>
          <PortalButton
            className="btn btn-info"
            disabled={!decision.allowed}
            onClick={() => {
              decision.reset();
              setReviewing(true);
            }}
          >
            <MdEdit /> Analisar documento
          </PortalButton>
          {reviewing && (
            <ReviewDecisionModal
              title="Analisar documento"
              description={document.requirement?.title || document.file_name}
              mutation={decision}
              onClose={() => setReviewing(false)}
              options={[
                ['approved', 'Aprovar documento'],
                ['rejected', 'Recusar documento'],
              ]}
              minLength={3}
              maxLength={5000}
            />
          )}
        </>
      )}
    </div>
  );
}
